import { checkingCredentials, login, logout } from ".";
import { AppDispatch } from "..";
import {
  loginUser,
  registerNormalUser,
} from "../../api/providers/authProviders";
import Cookies from "js-cookie";
//import { signInWithGoogle } from "../../providers/signInWithGoogle";

export const startGoogleSignIn = () => {
  return async (dispatch: AppDispatch) => {
    dispatch(checkingCredentials());

    /*  const result = await signInWithGoogle();
         if (!result.ok) return dispatch(logout({ errorMessage: 'No se pudo autenticar' }));
 
         dispatch(login(result)); */
  };
};

export const startRegisterNormalUser = (
  email: string,
  password: string,
  name: string
) => {
  return async (dispatch: AppDispatch) => {
    dispatch(checkingCredentials());

    if (!email || !password || !name)
      return dispatch(logout({ errorMessage: "Faltan datos" }));

    const result = await registerNormalUser({ email, password, name });

    if (!result.ok)
      return dispatch(logout({ errorMessage: result.errorMessage.error }));

    const now = new Date();

    const expirationDate = new Date(now.getTime() + 9 * 60 * 60 * 1000);

    Cookies.set("name", result.user.name, { expires: expirationDate });
    Cookies.set("email", result.user.email, { expires: expirationDate });
    Cookies.set("status", "authenticated", { expires: expirationDate });
    Cookies.set("token", result.token, { expires: expirationDate });

    dispatch(login(result));
  };
};

export const startLoginUser = (email: string, password: string) => {
  return async (dispatch: AppDispatch) => {
    try {
      dispatch(checkingCredentials());

      if (!email || !password) {
        throw new Error("Faltan datos");
      }

      const result = await loginUser({ email, password });

      if (!result.ok) {
        throw new Error(result.errorMessage.error);
      }

      const roles = result.user.roles || [];
      const isPlanner = roles.includes("PLANNER_ROLE");
      const roleToSet = isPlanner ? "PLANNER_ROLE" : "USER_ROLE";

      const now = new Date();

      const expirationDate = new Date(now.getTime() + 9 * 60 * 60 * 1000);

      Cookies.set("name", result.user.name, { expires: expirationDate });
      Cookies.set("email", result.user.email, { expires: expirationDate });
      Cookies.set("status", "authenticated", { expires: expirationDate });
 
      Cookies.set("role", roleToSet, { expires: expirationDate });
      Cookies.set("token", result.token, { expires: expirationDate });

      dispatch(login(result));

      return { success: true };
    } catch (error: any) {
      // Manejar errores de inicio de sesión
      dispatch(logout({ errorMessage: error.message }));
      return { success: false };
    }
  };
};

export const startLogout = () => {
  return async (dispatch: AppDispatch) => {
    dispatch(checkingCredentials());
    Cookies.remove("name");
    Cookies.remove("email");
    Cookies.remove("status");
   
    Cookies.remove("role");
    Cookies.remove("token");
    dispatch(logout({ errorMessage: null }));
  };
};
